import eventBus from 'commons/eventBus/eventBus';
import { defineStore } from 'pinia';

type CurrentToast = {
  variant?: 'info' | 'black' | 'warning' | 'error' | 'success' | 'loading-bar';
  text: string;
  timeout?: number;
  onRemove?: () => void;
  dismissible?: boolean;
  hideIcon?: boolean;
};

type State = {
  currentToast?: CurrentToast;
};

export const useToastsStore = defineStore('toasts', {
  state: (): State => ({
    currentToast: undefined,
  }),
  actions: {
    addToast({
      variant,
      text,
      timeout,
      onRemove,
      dismissible,
      hideIcon,
    }: CurrentToast) {
      this.currentToast = {
        variant,
        text,
        timeout: timeout || 4000,
        onRemove,
        dismissible,
        hideIcon,
      };

      eventBus.$emit('toasts:added');
    },
    removeToast() {
      if (this.currentToast?.onRemove) {
        this.currentToast?.onRemove();
      }
      this.currentToast = undefined;

      eventBus.$emit('toasts:removed');
    },
  },
});
